var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolVertecisLong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_219_4776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.17578 27C9.17578 17.0589 17.2347 9 27.1758 9H63.1758C73.1169 9 81.1758 17.0589 81.1758 27V63C81.1758 72.9411 73.1169 81 63.1758 81H27.1758C17.2347 81 9.17578 72.9411 9.17578 63V27Z",
    fill: "url(#paint0_linear_219_4776)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.847 51.4892C25.847 53.4945 27.4937 55.1414 29.4992 55.1414C30.9176 55.1414 32.1731 54.2936 32.76 53.087L57.347 60.2771C57.7383 61.8423 59.173 63 60.8688 63C62.8579 63 64.5046 61.3695 64.5046 59.3642C64.5046 57.8479 63.5589 56.5435 62.2545 56.0054L61.5535 39.5706C62.9557 39.0815 63.9665 37.7446 63.9665 36.163C63.9665 34.1576 62.3362 32.5272 60.347 32.5272C59.01 32.5272 57.8524 33.2446 57.2002 34.288L43.6187 30.5707C43.5697 28.5978 41.9557 27 39.9991 27C37.9937 27 36.347 28.6467 36.347 30.6522C36.347 31.7283 36.8198 32.6902 37.5698 33.375L30.0046 47.9185C29.8252 47.8696 29.6622 47.8532 29.4992 47.8532C27.4937 47.8532 25.847 49.4837 25.847 51.4892ZM32.1405 49.0109L39.722 34.2391C40.9937 34.4022 42.2165 33.7989 42.8687 32.788L56.7763 36.6033C56.8905 38.0217 57.9177 39.2446 59.2708 39.6522L59.8415 55.8588C58.7655 56.1685 57.8851 56.9674 57.4937 57.9946L33.0209 50.8043C32.9231 50.1033 32.6296 49.5326 32.1405 49.0109Z",
    fill: "url(#paint1_linear_219_4776)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_219_4776",
    x: 0.175781,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_219_4776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_4776",
    x1: 45.1758,
    y1: 9,
    x2: 45.1758,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_4776",
    x1: 45.1757,
    y1: 27,
    x2: 45.1757,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolVertecisLong);
export default __webpack_public_path__ + "static/media/symbol-vertecis-long.d743d0d85a9673397477bdbb24ea9ca9.svg";
export { ForwardRef as ReactComponent };